import {arrayTobject, setProps} from "@/utils";
import client from '@/services/';
import { parseInt } from "lodash";

const state = () => ({
    actu: {number: 1, content: {}}, all: {}, dgs: null,etap: {number: 1, content: {}}, allStatus: [],
    meteoList: {number: 1, content: {}}, p4wprojectsList: [],
});

const getters = {
    all: state => state.all,
    one: state => (id) => state.all[id],
    actu: state => state.actu,
    etap: state => state.etap,
    //CTU: state => (id) => state.actu.content[id],
    CTU: state => (id) => {
        for (const key in state.actu.content) {
            var value = state.actu.content[key];
            if(value.id === parseInt(id)){
                return state.actu.content[key];
            }
        }
    },
    last: state => state.actu.content,
    dgs: state => state.dgs,
    allStatus: state => state.allStatus,
    meteoList: state => state.meteoList,
    p4wprojectsList: state => state.p4wprojectsList,
};

const mutations = {
    SET_ALL: (state, obj) => state.all = arrayTobject(obj),
    SET_CTU: (state, obj) => state.actu = {
        ...state.actu, ...{
            ...obj, number: obj.number + 1, content: {
                ...state.actu.content,
                ...arrayTobject(obj.content)
            }
        }
    },
    SET_ETAP: (state, obj) => state.etap = {
        ...state.etap, ...{
            ...obj, number: obj.number + 1, content: {
                ...state.etap.content,
                ...arrayTobject(obj.content)
            }
        }
    },
    ADD_CTU: (state, item) => setProps(state.all, ['content', item.id], item),
    SET_DGS: (state, obj) => state.dgs = obj,
    SET_ALL_STATUS: (state, obj) => state.allStatus = obj,
    SET_METEO_LIST: (state, obj) => state.meteoList = {
        ...state.meteoList, ...{
            ...obj, number: obj.number + 1, content: {
                ...state.meteoList.content,
                ...arrayTobject(obj.content)
            }
        }
    },
    SET_P4WPROJECTS_LIST: (state, obj) => state.p4wprojectsList = obj,
};

const actions = {
    fetchDepart: async ({commit}) => {
        let {data} = await client.get('opens/departments');
        commit('SET_ALL', data)
    },
    fetchActu: async ({commit}, obj = {}) => {
        let {data} = await client.get('opens/actualites', {params: obj});
        commit('SET_CTU', data)
    },

    loadActu: async (context, id) => {
        if (!context.getters.CTU(id)) {
            let res = await client.get(`opens/actualites/${id}`);
            if (res.status === 200) context.commit('ADD_CTU', res.data);
        }
    },
    sendMail: async (context, payload) => {
        return await client.post('opens/contacts', payload); //if(res.status === 201) context.commit('ADD_BES', res.data);
    },
    sendMessage: async (context, payload) => {
        return await client.post('opens/messages/envoi', payload); //if(res.status === 201) context.commit('ADD_BES', res.data);
    },
    // Debut Actions BousProb
    fetchEtap: async ({commit}, obj = {}) => {
        let {data} = await client.get('opens/etapes', {params: obj});
        commit('SET_ETAP', data)
    },
    fetchEtapByAnnee: async ({commit}, obj = {}) => {
        let {data} = await client.get('opens/etapes/annee', {params: obj});
        commit('SET_ETAP', data)
    },
    fetchAtelier: async ({commit}, obj = {}) => {
        let {data} = await client.get('opens/etapes', {params: obj});
        commit('SET_ATEL', data)
    },
    sendRappel: async (context, payload) => {
        return await client.post('opens/rappel', payload); //if(res.status === 201) context.commit('ADD_BES', res.data);
    },
    sendRappelEtape: async (context, payload) => {
        return await client.post('opens/rappel', payload); //if(res.status === 201) context.commit('ADD_BES', res.data);
    },
    createParticipant: async (context, payload) => {
        return await client.post('opens/participant', payload); //if(res.status === 201) context.commit('ADD_BES', res.data);
    },
    init: async ({commit, getters}) => {
        //const pension = (rootGetters['parametre/list'] || []).find(({key}) => key === 'BVpSignBy');
        if (!getters.dgs) await Promise.all([
            client.get('opens/actualites'),
            client.get('parametres')
        ]).then(([n, p]) => {
            commit('SET_CTU', n.data)
            commit('SET_DGS', arrayTobject(p.data, 'key'))
        })
    },
    /* Store des methodes concernant GesPro ASIN */
    fetchMeteoNotValidated: async ({commit}, obj = {}) => {
        let {data} = await client.get('meteo/notValidated', {params: obj});
        commit('SET_METEO_LIST', data)
    },
    fetchP4wProjects: async ({commit}, obj = {}) => {
        let {data} = await client.get('p4wProjects/getP4wProjectsOfP4wProjectTasks', {params: obj});
        commit('SET_P4WPROJECTS_LIST', data)
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
